(function () {
  function updateAnnouncementHeight() {
    const announcement = document.querySelector('.section-announcement-bar');
    if (!announcement) {
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      return;
    }
    
    const isSticky = announcement.querySelector('.announcement-bar--sticky');
    const height = isSticky ? announcement.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
  }

  // Run immediately (don't wait for DOMContentLoaded if script is at bottom)
  updateAnnouncementHeight();
  
  document.addEventListener('DOMContentLoaded', updateAnnouncementHeight);
  window.addEventListener('resize', updateAnnouncementHeight);
  window.addEventListener('load', updateAnnouncementHeight); // catches font/image load shifts

  const target = document.querySelector('.section-announcement-bar');
  if (target && 'ResizeObserver' in window) {
    new ResizeObserver(updateAnnouncementHeight).observe(target);
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', updateAnnouncementHeight);
  document.addEventListener('shopify:section:unload', updateAnnouncementHeight);
})();